import { GzRadioWebComponent } from './component/GzRadioWebComponent';
import { GzRadioGroupWebComponent } from './component/GzRadioGroupWebComponent';
import { WEB_COMPONENT_GZ_RADIO, WEB_COMPONENT_GZ_RADIO_GROUP } from '../../webcomponents.constants';

export { GzRadioWebComponent, GzRadioGroupWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_RADIO, GzRadioWebComponent);
window.customElements.define(WEB_COMPONENT_GZ_RADIO_GROUP, GzRadioGroupWebComponent);
